/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'n_share': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path d="M12.33 6.67578C15.03 6.90828 16.1325 8.29578 16.1325 11.3333V11.4308C16.1325 14.7833 14.79 16.1258 11.4375 16.1258H6.55499C3.20249 16.1258 1.85999 14.7833 1.85999 11.4308V11.3333C1.85999 8.31828 2.94749 6.93078 5.60249 6.68328" stroke="#015FCC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 11.2498V2.71484" stroke="#015FCC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.5125 4.3875L9.00005 1.875L6.48755 4.3875" stroke="#015FCC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})